import { Button, Classes, Colors } from "@blueprintjs/core";
import styled from "@emotion/styled";

export const ToggleButton = styled(Button)`
  padding: 0;
  &.${Classes.MINIMAL}:hover,
    &.${Classes.MINIMAL}:focus,
    &.${Classes.MINIMAL}:active:focus {
    background: ${Colors.WHITE};
  }
  font-weight: 700;
  font-size: 16px;
  line-height: 24px;
`;
